import {TTrackingGameMode} from './Tracking.types'

export const getTrackingGameMode = (gameMode: any): TTrackingGameMode => {
  switch (gameMode) {
    case 'solo':
    case 'single_player':
      return 'single_player'
    case 'single':
      return 'party'
    case 'distributed':
      return 'event'
    default:
      return 'undefined'
  }
}
